import React from 'react';
import { Comment } from 'semantic-ui-react';
import MessageBubble from './MessageBubble';
import './MessageThread.css';

const MessageThread = ({ messages = [], currentUserId, otherParticipant }) => {
  if (messages.length === 0) {
    return (
      <div className="message-thread-empty">
        <p>No messages in this thread yet. Start the conversation!</p>
      </div>
    );
  }

  return (
    <div className="message-thread">
      <Comment.Group className="message-list">
        {messages.map((message, index) => {
          const isCurrentUser = message.sender?.userId === currentUserId;
          const showAvatar = index === 0 ||
            messages[index - 1]?.sender?.userId !== message.sender?.userId;

          return (
            <MessageBubble
              key={message.uuid}
              message={message}
              isCurrentUser={isCurrentUser}
              showAvatar={showAvatar}
              participant={isCurrentUser ? null : otherParticipant}
            />
          );
        })}
      </Comment.Group>
    </div>
  );
};

export default MessageThread;
